export const TOGGLE_HELP = 'TOGGLE_HELP';
export const RESET_HELP = 'RESET_HELP';
export const REQ_DATA = 'REQ_DATA';
export const RES_DATA = 'RES_DATA';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const SELECT_OPTION = 'SELECT_OPTION';
export const UPDATE_CONTEXT = 'UPDATE_CONTEXT';
export const CHART_UPDATE = 'CHART_UPDATE';
export const CHART_READY = 'CHART_READY';
export const CHART_HISTORY = 'CHART_HISTORY';
export const ERROR_THROWN = 'ERROR_THROWN';

// Costanti usate nelle tabs
export const DOMAINS = 'domain';
export const REGISTRANTS = 'registrant';
export const REGISTRARS = 'registrar';
export const DOMAINS_REGISTRATIONS = 'domains.registrations';
export const DOMAINS_CANCELLATIONS = 'domains.cancellations';
export const DOMAINS_TRANSFERS = 'domains.transfers';

export const DOMAINS_TRADES = 'domains.trades';
export const DOMAINS_RESTORES = 'domains.restores';
export const DOMAINS_GROWTH = 'domains.growth';


export const IMAGE_S = 'image.small';
export const IMAGE_M = 'image.medium';
export const IMAGE_L = 'image.large';

export const menuValues = {
    zone: ['italy', 'eu-north', 'eu-est', 'eu-west', 'eu-south', 'africa', 'amercas', 'asia', 'oceania'],
    area: ['', 'nord', 'centro', 'sud'],
}


export const NORTH_REGION = {
    label:'region',
    values:['emilia-romagna','friuli-venezia-giulia',
	    'liguria','lombardia','piemonte',
	    'trentino-alto-adige','valle-aosta', 'veneto']
};

export const SOUTH_REGION = {
    label:'region',
    values:['abruzzo','basilicata','calabria','campania',
	    'molise', 'puglia', 'sardegna','sicilia']
};

export const CENTER_REGION = {
    label:'region',
    values:['lazio','marche',
	    'toscana','umbria']
};

export const ZONE = {
    label: 'zone',
    values:['zone.italy','zone.europe-west',
	    'zone.europe-east','zone.america',
	    'zone.asia','zone.africa','zone.australia']
};


export const ZONES = {
    label: 'zone',
    values: ['zone.italy', 'zone.strangers']
}


export const AREA = {
    label: 'area',
    values:['area.all','area.north', 'area.center','area.south']
};
export const IT_AREA = ['area.italy.all','area.nord', 'area.centro','area.sud'];

//export const IT_AREA = ['all.italy','nord', 'centro','sud'];
// export const FOREIGN_AREA = ['all.foreign', 'africa', 'antartica',
// 'americas','asia','oceania',
// 'eu-east','eu-north','eu-south',
// 'eu-west'];
export const FOREIGN_AREA = [
  'area.foreign.all', 'area.africa','area.antartica',
  'area.americas','area.asia','area.oceania',
  'area.eu-east','area.eu-north','area.eu-south',
  'area.eu-west'
];


export const REGION =
    ["", NORTH_REGION, CENTER_REGION, SOUTH_REGION]



export const TIPOLOGY = {
    label: 'tipology',
    values:['tipology.all', 'tipology.naturalPerson',
	    'tipology.companies', 'tipology.freelance',
	    'tipology.noprofitCo','tipology.publicCo',
	    'tipology.other']
};


export const DRILLDOWN = ["yearly", "monthly", "daily", "hourly"];


/*
export const ITALY_REGISTRANTS = [
  'registrants.type.0', // Tutti i registranti
  'registrants.type.1', // Persone Fisiche
  'registrants.type.2', // Società e ditte
  'registrants.type.3', // Liberi Professionisti/Ordini Professionali
  'registrants.type.4', // Enti No Profit
  'registrants.type.5', // Enti Pubblici
  'registrants.type.6', // Altri Soggetti

];
*/
export const ITALY_REGISTRANTS = [
  'registrant.0', // Tutti i registranti
  'registrant.1', // Persone Fisiche
  'registrant.2', // Società e ditte
  'registrant.3', // Liberi Professionisti/Ordini Professionali
  'registrant.4', // Enti No Profit
  'registrant.5', // Enti Pubblici
  'registrant.6', // Altri Soggetti

];

export const ITALY_EDU_REGISTRANTS = [
    'registrant.0', // Tutti i registranti
    'registrant.2',
    'registrant.4',
    'registrant.5'
];

export const REGIONS = {
  "nord": ["Emilia-Romagna",
	   "Friuli-Venezia Giulia",
	   "Liguria",
	   "Lombardia",
	   "Piemonte",
	   "Trentino-Alto Adige",
	   "Valle d'Aosta",
	   "Veneto"],
    "centro": ["Lazio",
	       "Marche",
	       "Toscana",
	       "Umbria"],
    "sud": ["Abruzzo",
	    "Basilicata",
	    "Calabria",
	    "Campania",
	    "Molise",
	    "Puglia",
	    "Sardegna",
	    "Sicilia"]
};


export const EU_REGISTRANTS = [
  'registrant.0',
  'registrant.1',
  'registrant.7'
];


export const REGISTRANTS_CONTROL = [
    ZONE,
    AREA,
//    REGION,
    TIPOLOGY
];



// WEBPACK FOOTER //
// ./src/constants/index.js